module.exports = __webpack_public_path__ + "img/button_download.ee656435.svg";